import { Element,Listen,Fragment,Component, Prop, h, State, Host } from '@stencil/core';
import { getServiceNumber } from '../../utils/ttarp';
import { setFeatureFlagsFromUrl, signaler } from '../../utils/signaler';
import helpIcon from '../../assets/help-circle.svg';
import logoLargeHorizontal from '../../assets/logo-large-horizontal.svg';
import { desktopBannerMessage, isBrowser, mobileBannerMessage } from '../../constants/constants';
import { isUserLoggedIn } from '../../utils/is_user_logged_in';
import logo from '../../assets/logo.svg';
import { getOrSetFeatureAssignment } from '../../utils/scSignalman';
import { isBeforePromoExpiry } from '../../utils/promoExpire';
import { trackAnalyticsEvent } from '../../utils/analytics';

@Component({
  tag: 'ci-header',
  styleUrl: 'ci-header.scss',
  assetsDirs: ['.../assets'],
  scoped: true,
})
export class CustominkHeader {
  @Element() $el: HTMLElement;
  @Prop() serviceNumber: string; // Allow an optional serviceNumber prop
  @Prop() mobileBannerMessage: string = mobileBannerMessage;
  @Prop() desktopBannerMessage: string = desktopBannerMessage;
  @Prop() simple = false;
  @Prop() showCart = true;
  @Prop() cartDetail = false;
  @Prop() cartPricing = false;
  @Prop() detailedQuantities = false;
  @State() signaler = signaler;
  @State() dynamicServiceNumber: string = '';
  @State() isFramer: boolean;
  @State() searchInHeaderTest: boolean;
  @State() visibleMenuBtn: boolean;
  @State() showMenu: boolean;
  @State() visibleMobileVisibility: boolean;
  @State() visibleOverlay: boolean;
  @State() adTest: boolean = false;
  private dialog!: HTMLCiDialogElement

  async componentWillLoad() {
    if (isBrowser) {
      setFeatureFlagsFromUrl(this.signaler);
      window.dispatchEvent(new Event('ciHeaderLoaded'));

      // If serviceNumber prop is not provided, fetch the dynamic service number
      if (!this.serviceNumber) {
        const fetchedServiceNumber = await getServiceNumber(); // Wait for the service number to resolve
        this.dynamicServiceNumber = fetchedServiceNumber;
      } else {
        this.dynamicServiceNumber = this.serviceNumber;
      }

      this.searchInHeaderTest = signaler.featureFlag('search_header_v7') === 'test';
      const url = window.location.href;
      this.isFramer = url.includes('iframer');

      try {
        const assignment = await getOrSetFeatureAssignment('drinkware_promo_ad_v2');
        this.adTest = assignment === 'on' && isBeforePromoExpiry();
      } catch (_err) { }
    }
  }
  // add Add to SB footer
  async componentDidLoad() {
    if (!isBrowser || !this.adTest) return;

    if (window.dataLayer) {
      window.dataLayer.push({
        event: "view_promotion",
        ecommerce: {
          creative_name: "Header",
          creative_slot: "Announcement Bar",
          promotion_id: 5,
          promotion_name: "May 2025 Drinkware Promo"
        }
      });
    }

    const tryInsertBanner = () => {
      const footer = document.querySelector('.sb-Footer');
      if (footer) {
        const newDiv = document.createElement('div');
        newDiv.className = 'ciSbFooter-BannerAd';
        newDiv.innerHTML = '<div class="sb-Wrapper" id="footer-banner-ad-terms" style="text-align: left; padding-top: 1rem; padding-bottom: 1rem;"><strong style="font-weight: bold;">*20% Off Drinkware Promo:</strong> Valid thru 11:59 PM PDT 5/26/25. Prices as marked. Discount does not apply to taxes or shipping. <br class="sb-Util-visible--xl" />Cannot be combined with other rebates or offers, including <span style="white-space: nowrap;">negotiated pricing.</span></div>';
        footer.parentNode?.insertBefore(newDiv, footer);
        return true;
      }
      return false;
    };
    if (tryInsertBanner()) {
      return;
    }
    const observer = new MutationObserver((_, obs) => {
      if (tryInsertBanner()) {
        obs.disconnect();
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

  }
  // End footerBannerAd


  private handlePromotionClick = () => {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: "select_promotion",
        ecommerce: {
          creative_name: "Header",
          creative_slot: "Announcement Bar",
          promotion_id: 5,
          promotion_name: "May 2025 Drinkware Promo"
        }
      });
    }
  };

  private hideMenuTimeout: number;

  @Listen('pointerdown', { target: 'document' })
  handleOutsideInteraction(event: PointerEvent) {
    const componentRoot = this.$el;
    if (!componentRoot.contains(event.target as Node)) {
      this.showMenu = false;
    }
  }

  @Listen('keydown', { target: 'document' })
  handleEscapeKey(event: KeyboardEvent) {
    if (event.key === 'Escape' && this.showMenu) {
      this.getAccountsModal(event.target).closeModal(event);
    }
  }

  private getAccountsModal(target: EventTarget): HTMLCiDialogElement | null {
    const parent = (target as HTMLElement).closest('.accounts');
    const accountsEl = parent?.querySelector('ci-accounts');
    return accountsEl.shadowRoot.querySelector('ci-dialog');
  }

  private handleMouseEnter = (event) => {
    window.clearTimeout(this.hideMenuTimeout);
    this.getAccountsModal(event.target).openModal(event);
  };

  private handleMouseLeave = (event) => {
    this.hideMenuTimeout = window.setTimeout(() => {
      this.getAccountsModal(event.target).closeModal(event);
    }, 200);
  };

  private handleTouchStart = (e: Event) => {
    e.preventDefault();
      this.getAccountsModal(e.target).openModal(e);
  };

  private handleTouchEnd = (e: Event) => {
    e.preventDefault();
  };

  private renderHelpMenu(){
    return (
      <div class="customer-help">
        {this.simple &&(
          <Fragment>
            <ci-dialog
              name="We’re Here To Help"
              ref={(el) => (this.dialog = el)}
            >
              <p id='customer-subtitle' slot="dialog-content" >
                Need a hand? Get personalized support from our expert team.
              </p>
              <div class="customer-actions" slot="dialog-actions">
                <a href={`tel:${this.dynamicServiceNumber}`} class="tertiary-secondary-button">
                  <customer-contact serviceNumber={this.dynamicServiceNumber}></customer-contact>
                </a>
                <button onClick={this.handleShowChat} >
                  <customer-chat/>
                </button>
              </div>
            </ci-dialog>
            <button id="customer-btn" onClick={this.handleShowModal}>
              <img src={helpIcon} alt="phone icon" class="customer-help-icon" />
              <span>Help</span>
            </button>
          </Fragment>
        )}
        <customer-contact serviceNumber={this.dynamicServiceNumber}></customer-contact>
        <customer-chat></customer-chat>
      </div>
    )
  }


  private renderCartAndAccount(isUserLogged: boolean) {
    return (
      <Fragment>
        <div class="accounts" onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave}>
          <a
            href={`${process.env.CI_HOSTNAME}/profiles/retrieve`}
            class="ciHeader-accounts-btn"
            onTouchStart={this.handleTouchStart}
            onTouchEnd={this.handleTouchEnd}
            data-section="my account"
            data-link="my account"
            data-testid="my-account"
            onClick={trackAnalyticsEvent}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M17.5 7.5C17.5 10.5376 15.0376 13 12 13C8.96243 13 6.5 10.5376 6.5 7.5C6.5 4.46243 8.96243 2 12 2C15.0376 2 17.5 4.46243 17.5 7.5ZM8 16.5C6.34315 16.5 5 17.8431 5 19.5V21C5 21.5523 4.55228 22 4 22C3.44772 22 3 21.5523 3 21V19.5C3 16.7386 5.23858 14.5 8 14.5H16C18.7614 14.5 21 16.7386 21 19.5V21C21 21.5523 20.5523 22 20 22C19.4477 22 19 21.5523 19 21V19.5C19 17.8431 17.6569 16.5 16 16.5H8ZM12 11C13.933 11 15.5 9.433 15.5 7.5C15.5 5.567 13.933 4 12 4C10.067 4 8.5 5.567 8.5 7.5C8.5 9.433 10.067 11 12 11Z"
                fill="#4A4A4A"
              />
            </svg>
            <span class="ciHeader-accounts-btn-text">
              {isUserLogged ? 'My Account' : 'Sign In'}
            </span>
            {this.simple && (<span class="ciHeader-accounts-btn-text--mobile">
              {isUserLogged ? 'Account' : 'Sign In'}
            </span>)}
          </a>
          <ci-accounts
            isUserLogged={isUserLogged}
            isSimple={this.simple}
          ></ci-accounts>
        </div>
        {this.showCart && (
          <ci-cart
            pricing={this.cartPricing}
            detail={this.cartDetail}
            detailedQuantities={this.detailedQuantities}
            data-section="my cart"
            data-link="my cart"
            onClick={trackAnalyticsEvent}
          />
        )}
      </Fragment>
    )
  }

  private renderBannerAd(){
    return (
      <div class="bannerAd">
        <span class="bannerAd-text">
          Save 20% off drinkware-prices as marked. Offer ends May 26.*</span>
        <span>
        <a
          class="bannerAd-cta"
          href={`${process.env.CI_HOSTNAME}/products/drinkware/all-drinkware/477`}
          onClick={this.handlePromotionClick}
        >
          Shop the Sale
        </a>
        </span>
      </div>
    );
  }

  private handleShowModal = (e) => {
    this.dialog.openModal(e);
  }

  private handleShowChat = (e) => {
    e.preventDefault();
    (this.$el.querySelector('#LP_') as HTMLElement)?.click();
    this.dialog.forceClose();
  }

  render() {
    const isUserLogged = isUserLoggedIn();

    const onMenuBtnClick = () => {
      this.visibleMenuBtn = !this.visibleMenuBtn;
      const ciBodyTag = document.getElementsByTagName('body')[0] as HTMLElement;

      if (this.visibleMenuBtn) {
        this.visibleMobileVisibility = !this.visibleMobileVisibility;
        ciBodyTag.style.overflow = 'hidden';
      } else {
        setTimeout(() => {
          this.visibleMobileVisibility = !this.visibleMobileVisibility;
          ciBodyTag.style.overflow = 'visible';
        }, 200);
      }
    };
    return (
      <Host>
        <div class={{
          'overlay': true,
          'activeOverlay': this.visibleOverlay,
          'closeOverlay': !this.visibleOverlay,
        }} />
        {!this.simple && isBrowser && (
          <div
            class={{
              'banner-container':true,
              'banner-container--withAd': this.adTest,
            }}
          >
            {this.adTest && this.renderBannerAd()}
            <div class="banner">
              <div class="banner-title">
                <span class="banner-title--desktop">{this.desktopBannerMessage}</span>
                <span class="banner-title--mobile">{this.mobileBannerMessage}</span>
              </div>
              <div class="banner-actions">
                <ci-local-store></ci-local-store>
                <a class="banner-ttarpMobile ciHeader-phoneNumberLink" href={`tel:${this.dynamicServiceNumber}`}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M10.9984 7.34492L9.93931 8.40398C9.35415 8.98914 9.35523 9.94081 9.94287 10.5284L13.4717 14.0573C14.0631 14.6487 15.0105 14.6465 15.5962 14.0608L16.6552 13.0018C17.0467 12.6103 17.68 12.6087 18.0721 13.0008L21.9594 16.8881C22.5457 17.4744 22.5484 18.4223 21.957 19.0137L19.8371 21.1336C18.4713 22.4994 15.9919 22.8586 14.3339 21.8664C14.3339 21.8664 11.6781 20.749 7.48967 16.5605C3.30124 12.3721 2.14268 9.66692 2.14268 9.66692C1.17668 7.993 1.50444 5.52515 2.86652 4.16306L4.98642 2.04317C5.57405 1.45553 6.52203 1.45076 7.11201 2.04074L10.9993 5.92807C11.3903 6.31905 11.3912 6.95209 10.9984 7.34492ZM4.28074 5.57727C3.55726 6.30075 3.43484 7.74857 3.87493 8.66726C3.87493 8.66726 4.58135 9.94921 4.9011 10.421C5.84618 11.8154 7.16049 13.4029 8.90389 15.1463C10.647 16.8894 12.2247 18.1956 13.6027 19.1273C14.0679 19.4419 15.3609 20.1502 15.3609 20.1502C16.198 20.5883 17.6864 20.4558 18.4229 19.7194L20.1926 17.9497L17.3641 15.1213L17.0104 15.475C15.6421 16.8434 13.4284 16.8424 12.0575 15.4715L8.52865 11.9427C7.1611 10.5751 7.15776 8.35711 8.5251 6.98977L8.87885 6.63601L6.05043 3.80758L4.28074 5.57727Z"
                      fill="var(--fill-text)"
                    />
                  </svg>
                  <span class="banner-ttarpMobile-text">Help</span>
                </a>
              </div>
            </div>
          </div>
        )}
        <div class="main-container">
          <div
            class={{
              ciHeader: true,
              'simple': this.simple,
            }}>
            <div class="ciHeader-subNav">
              <div class={{
                "ciHeader-mobile-menu-btn": true,
                "active": this.visibleMenuBtn
              }} id="menuButton"
                onClick={onMenuBtnClick}
              >
                <span />
                <span />
                <span />
              </div>
              <ci-mobile-subnav
                serviceNumber={this.dynamicServiceNumber}
                visible={this.visibleMobileVisibility}
                visibleDrawer={this.visibleMenuBtn}
                onCloseDrawer={onMenuBtnClick}
                ></ci-mobile-subnav>
              <a href={`${process.env.CI_HOSTNAME}`} class="ciHeader-logo">
                <picture>
                  {this.simple && <source media="(max-width: 699px)" srcSet={logo} />}
                  <img alt="customink logo - inky" class="ciHeader-logo-image" src={logoLargeHorizontal} />
                </picture>
              </a>
            </div>
            {!this.simple && !this.isFramer && <ci-search id="searchOverlay"></ci-search>}
            {this.renderHelpMenu()}
            {this.renderCartAndAccount(isUserLogged)}
            <slot/>
          </div>
        </div>
        {!this.simple && (
          <div class="navigation-container">
            <div class='navigation'>
              <ci-navigation
                onOpenOverlay={() => {
                  this.visibleOverlay = true
                }}
                onCloseOverlay={() => {
                  this.visibleOverlay = false
                }}
              ></ci-navigation>
              {this.renderCartAndAccount(isUserLogged)}
            </div>
          </div>
        )}
      </Host>
    );
  }
}
